import axios from "@/libs/api.request";
import {getToken} from "@/libs/util";
// 海运增删改查
export const operSea = params => {
  return axios.request({
    url: `/common/sea${params.id ? "/" + params.id : ""}`,
    [params.method == "get" ? "params" : "data"]: params,
    method: params.method
  });
};

// 获取船公司列表
export const getShipCompany = params => {
  return axios.request({
    url: "/common/transport/company",
    params,
    method: "get"
  });
};

// 获取出单方式
export const getBillType = params => {
  return axios.request({
    url: "/common/transport/issueType",
    params,
    method: "get"
  });
};

// 获取柜型
export const getContainerType = params => {
  return axios.request({
    url: "/common/transport/cabinetType",
    params,
    method: "get"
  });
};

// 创建海运提单
export const operSeaOrder = params => {
  return axios.request({
    url: `/extract/extract_sea${params.id ? "/" + params.id : ""}`,
    [params.method == "get" ? "params" : "data"]: params,
    method: params.method
  });
};

// 获取港口
export const getPort = params => {
  return axios.request({
    url: "/common/transport/seaPort",
    params,
    method: "get"
  });
};

// 获取b2b订单详情
export const getB2bOrderDetail = params => {
  return axios.request({
    url: `/extract/extract_sea/getDblOrder/${params.id}`,
    params,
    method: "get"
  });
};


export const createBill = (params) => {
  return axios.request({
    url: `/extract/extract_sea/createBill`,
    params,
    method: "get",
  });
};

export const airway_number = params => {
  return axios.request({
    url: "/extract/extract_sea/airway_number",
    params,
    method: "get"
  });
};

export const add_number = data => {
  return axios.request({
    url: "/extract/extract_sea/add_number/"+data.id,
    data,
    method: "post"
  });
};

export const relation_number = data => {
  return axios.request({
    url: "/extract/extract_sea/relation_number/"+data.id,
    data,
    method: "get"
  });
};

export const del_number = data => {
  return axios.request({
    url: "/extract/extract_sea/del_number/"+data.id,
    data,
    method: "post"
  });
};

export const uploadFile = data => {
  return axios.request({
    url: `/extract/extract_sea/uploadAttachment`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data,
  });
}

export const seaBoxArray = data => {
  return axios.request({
    url: "/extract/extract_sea/uploadHistory/"+data,
    method: "get"
  });
}

export const searchCustomer = data => {
  return axios.request({
    url: "/common/customer/auto?keywords="+data,
    method: "get"
  });
}

export const batchUpdateTime = data => {
  return axios.request({
    url: "/extract/extract_sea/updateTimeValue",
    data,
    method: "post"
  });
}
